<template>
  <div class="footer-main">
    <div class="left-footer-content">
      <span class="text">
        © {{ edition }}
        &nbsp;&nbsp;&nbsp;&nbsp;备案号：{{ recordNumber }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { EDITION, SYSTEM_NAME, COMPANY, PHONE, RECORD_NUMBER } from "@/constant/Const";

const edition = EDITION;
const systemName = SYSTEM_NAME;
const company = COMPANY;
const phone = PHONE;
const recordNumber = RECORD_NUMBER;
</script>

<style lang="less" scoped>
.footer-main {
  background-color: #333;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-footer-content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text {
  color: #fff;
  font-size: 14px;
}
</style>
